export const DOCTOR_STATUS_MAPPED = new Map([
  [1, 'Active'],
  [2, 'Deactive']
])
